import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import useQuery from "../../../../shared/components/hooks/useQuery";
import SearchBox from "../../../../layouts/SidebarLayout/Header/SearchBox";
import { TableViewContainer } from "../../../../shared/components/tableViewContainer";
import Loader from "../../../../shared/components/loader/linearProgress";
import NoPermissionContent from "../../../../shared/components/noPermissionBanner";
import DataTable from "../../../../shared/components/dataTable";


const ServicesList: FC = () => {
  const navigate = useNavigate();
  const { payload, setPayload } = useContext(SidebarContext);

  const { loading, data, fetchData, error } = useQuery("/services", {
    params: {
      ...payload,
    },
  });

  const serviceData = (data as any);

  const navigateToDetails = () => {
    navigate("/services/create");
  };

  const jobTypesDisplayColumns = ["name", "enabled"];
  const titleBarNode = <SearchBox />;
  const titleBar = {
    title: "Services",
    headerTitle: "Services",
    buttonTitle: "Create",
    titleBarNodes: titleBarNode,
    onClick: navigateToDetails,
    disabled: serviceData?.entityPermissions
      ? !serviceData?.entityPermissions?.includes("Service-Create")
      : false,
    subHeading: '',
    rowCount: serviceData?.totalItems,
  };

  return (
    <TableViewContainer titleBar={titleBar}>
      {loading && <Loader />}
      {(error as any)?.statusCode === 403 && <NoPermissionContent />}
      {!loading && !error && (
        <DataTable
          entityName="Services"
          data={serviceData?.items ?? []}
          displayColumns={jobTypesDisplayColumns}
          linkColumn="name"
          linkUrl="/services"
          pagination={{ take: payload.take, skip: payload.skip }}
          setPagination={setPayload}
          totalItems={serviceData?.totalItems}
          deleteApiUrl="/services"
          refetchFunction={fetchData}
          disabled={
            serviceData?.entityPermissions
              ? !serviceData?.entityPermissions?.includes("Service-Delete")
              : false
          }
        />
      )}
    </TableViewContainer>
  );
}

export default ServicesList;